"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildForumPlaceholderTeasers = exports.FORUM_PLACEHOLDER_ROW_COUNT = void 0;
/** Fixed row count for locked-audience marketing teasers — does not reveal how many real forums exist. */
exports.FORUM_PLACEHOLDER_ROW_COUNT = 3;
var PLACEHOLDER_FORUM_LABELS = ['Community discussions', 'Industry insights', 'Member support'];
/** Safe marketing rows for users who can see Forums nav but are not in the audience. No real channel data. */
var buildForumPlaceholderTeasers = function (rowCount) {
    if (rowCount === void 0) { rowCount = exports.FORUM_PLACEHOLDER_ROW_COUNT; }
    var count = Math.max(0, Math.min(rowCount, PLACEHOLDER_FORUM_LABELS.length));
    return Array.from({ length: count }, function (_, index) { return ({
        _id: "forum-placeholder-".concat(index),
        name: PLACEHOLDER_FORUM_LABELS[index],
        order: index,
        participantCount: 24 + index * 11,
        topicCount: 6 + index * 4,
        accessible: false,
        placeholder: true,
    }); });
};
exports.buildForumPlaceholderTeasers = buildForumPlaceholderTeasers;
//# sourceMappingURL=forumTeaser.js.map